import React from 'react';
import { Box, Grid2, Typography } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

export default function AboutMe({ darkMode }) {
    return (
        <Grid2
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            height={`calc(100vh)`}
            textAlign="center"
            sx={{
                px: 1,
                backgroundColor: darkMode ? '#0E0E0F55' : '#F5F5F5CB',
            }}
        >
            <Grid2 item xs={12} md={8} lg={6} xl={6}>
                <Box
                    component="section"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2,
                        margin: 1,
                    }}
                    maxWidth={800}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <RocketLaunchIcon fontSize="large" />
                        <Typography variant="h2" fontWeight={500}>
                            Sobre mim
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'left' }}>
                        <Typography variant="h6" fontWeight={400} align="justify">
                            Graduado em Sistemas de Informação pela USP, atualmente sou Engenheiro de
                            Software na Von Braun Labs, com foco no desenvolvimento Frontend e UI/UX.
                        </Typography>

                        <Typography variant="h6" fontWeight={400} align="justify">
                            Atuo no frontend e design de interface de
                            plataformas EDA em nuvem (como ChipInventor e ChampionChip Experience),
                            criando uma ferramenta visual e colaborativa que ajuda a
                            democratizar o design de semicondutores no Brasil e no mercado
                            internacional.
                        </Typography>

                        <Box>
                            <Typography variant="h6" fontWeight={500}>
                                Minha trajetória inclui:
                            </Typography>
                            <Box component="ul" sx={{ margin: 0, marginTop: 1, paddingLeft: 3 }}>
                                <Typography component="li" variant="h6" fontWeight={400}>
                                    Desenvolvimento Frontend robusto com React (SPA/SSR), Angular e
                                    TypeScript.
                                </Typography>
                                <Typography component="li" variant="h6" fontWeight={400}>
                                    Forte envolvimento com design para criar experiências de usuário
                                    (UI/UX) fluidas em plataformas web e mobile.
                                </Typography>
                                <Typography component="li" variant="h6" fontWeight={400}>
                                    Experiência em diversos ambientes e projetos, atuando desde a
                                    integração com APIs e microsserviços (Node.js/.NET) até
                                    ecossistemas mobile integrado a hardware para rastreamento
                                    (RFID/Bluetooth) com apps publicados na Google Play Store.
                                </Typography>
                                <Typography component="li" variant="h6" fontWeight={400}>
                                    Passagem pelo Grupo OLX, implementando soluções para o PaaS
                                    interno (COPS) responsável por melhorar a experiência de deploy
                                    na infraestrutura em nuvem.
                                </Typography>
                            </Box>
                        </Box>

                        <Typography variant="h6" fontWeight={500} align="justify">
                            Sou movido pelo desafio de transformar requisitos em soluções
                            técnicas sofisticadas e eficientes. Vamos conversar? 🚀
                        </Typography>
                    </Box>
                </Box>
            </Grid2>
        </Grid2>
    );
}
